/**
 * Shows a video-input form
 */
import React from 'react';
import PropTypes from 'prop-types';
import i18n from '../../../../shared/locales/no.json';
import SubmitButton from '../../../components/form/formComponents/SubmitButton';
import Form from '../../../components/form/Form';
import Input from '../../../components/form/formComponents/Input';

export default class VideoInput extends React.Component {
    static propTypes = {
        profileId: PropTypes.number,
        onAdd: PropTypes.func.isRequired,
        mode: PropTypes.string,
        errorMsg: PropTypes.string,
    };

    onSubmit = (model) => {
        const videoUrl = model.videoUrl;

        this.props.onAdd(this.props.profileId, { href: videoUrl.trim() });
        this.form.reset();
    };

    render() {
        return (
            <div className="panel">
                <Form
                    onValidSubmit={this.onSubmit}
                    ref={(ref) => {
                        this.form = ref;
                    }}
                >
                    <Input
                        autoFocus={false}
                        classes="input input--text u-mb0"
                        id="video-url"
                        label={i18n.video.label}
                        name="videoUrl"
                        required
                        serverError={this.props.errorMsg}
                        type="url"
                    />

                    <div className="u-mv16">
                        <SubmitButton
                            className="button--small u-mt8"
                            data_fth_event="add_video"
                            mode={this.props.mode}
                            value={i18n.video['add-button']}
                        />
                    </div>
                </Form>
            </div>
        );
    }
}
